import { ChainModel } from 'types/ChainModel';
import axios from '../utils/axios';

export async function getChainModels(): Promise<ChainModel[]> {
  return axios.get('/models-chain').then((res) => res.data);
}

export async function createChainModel(
  data: Omit<ChainModel, 'id' | 'creation_ts' | 'edit_ts' | 'resolved_model'>
): Promise<ChainModel> {
  return axios.post('/models-chain', data).then((res) => res.data);
}

export async function updateChainModel(
  id: string,
  data: Partial<ChainModel>
): Promise<ChainModel> {
  return axios.put(`/models-chain/${id}`, { ...data, id }).then((res) => res.data);
}

export async function deleteChainModel(id: string): Promise<void> {
  return axios.delete(`/models-chain/${id}`).then((res) => res.data);
}
